<template>
  <div class="contents">
    <div class="detail_wrap">
      <h4 class="category">후원활동</h4>
      <div class="tit_wrap">
        <h5 class="tit">{{ sponsor.sponsorTitle }}</h5>
        <div class="sub">{{ sponsor.sponsorContent }}</div>
      </div>
      <div class="cont_wrap">
        <div class="cont">
          <p style="display:none;">
            <img src="" alt="" />
          </p>
          <p style="background-color: #e3e3e3; width: 900px; height: 370px; margin: 0 auto; text-align: center; line-height: 370px; font-size: 18px; font-weight: 600; display:none;"></p>
          <p style="text-align: center; font-size: 18px; margin-top: 50px; font-weight: 500; line-height: 1.8;" v-html="sponsor.editorHtml"></p>
        </div>
      </div>
      <div class="btn_wrap">
        <a href="/sponsor" class="btn_list">목록</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

const sponsorModule = "sponsorModule";

export default {
  props: {
    sponsorSeq: {
      type: String,
      required: true,
    },
  },

  methods: {
    ...mapActions(sponsorModule, ["requestSponsor"]),

    toList() {
      this.$router.push({ name: "SponsorListPage" });
    },
  },

  computed: {
    ...mapState(sponsorModule, ["sponsor"]),
  },

  async mounted() {
    await this.requestSponsor(this.sponsorSeq);
    console.log(this.sponsor);
  },
};
</script>
